import React from 'react';
import { Link } from 'gatsby';
import { CircleUser, Menu, Package2, Search } from 'lucide-react';

import { useSiteMetadata } from '../hooks/use-site-metadata';
import { useAllCategories } from '../hooks/use-all-categories';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuIndicator,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
  NavigationMenuViewport,
} from './ui/navigation-menu';
import { Sheet, SheetContent, SheetDescription, SheetTitle, SheetTrigger } from './ui/sheet';
import { Button } from './ui/button';
import Logo from './ui/logo';
import SocialIcons from './ui/social-icons';
import { Separator } from './ui/separator';

const Navigation = () => {
  const { navigation } = useSiteMetadata();
  const categories = useAllCategories();

  return (
    <>
      <nav className='hidden flex-col text-lg font-medium md:flex md:flex-row md:items-center md:text-sm ml-20'>
        <NavigationMenu>
          <NavigationMenuList>
            <NavigationMenuItem>
              <NavigationMenuTrigger>Categories</NavigationMenuTrigger>
              <NavigationMenuContent>
                {categories.map((category, i) => {
                  return (
                    <Link
                      to={`/${category}`}
                      className={`group flex justify-between items-center gap-5 h-10 rounded-md px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50`}
                      activeClassName='text-accent-foreground bg-accent/50'
                      key={`${category + i}`}
                    >
                      <span>{`${category[0].toUpperCase()}${category.slice(1)}`}</span>
                    </Link>
                  );
                })}
              </NavigationMenuContent>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>
        {navigation.map((navLink, i) => {
          return (
            <Link
              to={navLink.path}
              className={navigationMenuTriggerStyle()}
              key={navLink.name}
              activeClassName='text-accent-foreground bg-accent/50'
              partiallyActive={true}
            >
              {navLink.name}
            </Link>
          );
        })}
      </nav>
      <Sheet>
        <SheetTrigger asChild>
          <Button variant='outline' size='icon' className='shrink-0 md:hidden'>
            <Menu className='h-5 w-5' />
            <span className='sr-only'>Toggle navigation menu</span>
          </Button>
        </SheetTrigger>
        <SheetContent side='left' className='my-5'>
          <SheetTitle className='my-5'>
            <Link to='/'>
              <Logo />
            </Link>
          </SheetTitle>
          <nav className='grid gap-6 text-lg font-medium my-10'>
            <Link
              to='/categories'
              className='text-muted-foreground hover:text-foreground'
              activeClassName='text-accent-foreground bg-accent/50'
            >
              Categories
            </Link>
            {navigation.map((navLink, i) => {
              return (
                <Link
                  to={navLink.path}
                  className='text-muted-foreground hover:text-foreground'
                  activeClassName='text-accent-foreground bg-accent/50'
                  key={navLink.name}
                >
                  {navLink.name}
                </Link>
              );
            })}
          </nav>
          <Separator className='my-5' />
          <SheetDescription>Follow Us</SheetDescription>
          <SocialIcons styleClass='my-10' />
        </SheetContent>
      </Sheet>
    </>
  );
};
export default Navigation;
